export enum AdBuilderAgentToolName {
  AddLayer = 'AddLayer',
  AddLayer2 = 'AddLayer2',
  AddTextLayer = 'AddTextLayer',
  AddImageLayer = 'AddImageLayer',
  AddShapeLayer = 'AddShapeLayer',
  GetAvailableAssets = 'GetAvailableAssets',
  LetUserSeeOrSelectAsset = 'LetUserSeeOrSelectAsset',
  EditLayerTransform = 'EditLayerTransform',
  EditLayerTransform2 = 'EditLayerTransform2',
  EditLayerContent = 'EditLayerContent',
  DeleteLayers = 'DeleteLayers',
  DuplicateLayers = 'DuplicateLayers',
  GetLayerDetails = 'GetLayerDetails',
  PromptToImage = 'PromptToImage',
  UpdateLayerGeneralParams = 'UpdateLayerGeneralParams',
  SelectLayers = 'SelectLayers',
  AddTextAnimator = 'AddTextAnimator',
  AddOrEditTextAnimator = 'AddOrEditTextAnimator',
  GetTransitionDescriptionAndInstructions = 'GetTransitionDescriptionAndInstructions',
  AddVideoLayer = 'AddVideoLayer',
  ImportAssetFromBrandAssets = 'ImportAssetFromBrandAssets',
  ExtractTextLayersFromImage = 'ExtractTextLayersFromImage',
}
